// InSAR ground truth (GET devices/<mac>/insar/): Sentinel-1 acquisitions over a node, newest first, each with the
// node's water at that minute, and ESA's planned ones ahead. Pure helpers: anything that is not the endpoint's answer
// reads as null.

const num = (v) => (typeof v === "number" && Number.isFinite(v) ? v : null);
const str = (v) => (typeof v === "string" ? v : null);

export function readInsar(data) {
  if (!data || typeof data !== "object" || !Array.isArray(data.rows)) return null;
  const rows = data.rows
    .filter((r) => r && num(r.t) !== null && (r.status === "acquired" || r.status === "planned"))
    .map((r) => {
      const w = r.water && typeof r.water === "object" ? r.water : null;
      return {
        t: r.t,
        local: str(r.local),
        status: r.status,
        satellite: str(r.satellite) || "",
        direction: str(r.direction),
        track: num(r.track),
        incidenceDeg: num(r.incidence_deg),
        water: w
          ? { state: str(w.state), ourMm: num(w.our_mm), depthMm: num(w.depth_mm), belowTube: w.depth_below_tube === true, gapS: num(w.gap_s) }
          : null,
      };
    });
  const c = data.catalogue && typeof data.catalogue === "object" ? data.catalogue : null;
  const problem = data.problem && typeof data.problem === "object" ? str(data.problem.detail) : null;
  return { rows, days: num(data.days), catalogueError: c ? str(c.error) : null, problem };
}

// "descending, track 18, 40°"
export function passText(r) {
  const parts = [r.direction, r.track !== null ? `track ${r.track}` : null, r.incidenceDeg !== null ? `${Math.round(r.incidenceDeg)}°` : null];
  return parts.filter(Boolean).join(", ");
}

// The water when the radar imaged the field, in a few words.
export function waterText(r) {
  if (r.status === "planned") return "Planned by ESA";
  const w = r.water;
  if (!w) return "No reading within 20 min";
  if (w.belowTube) return "Dry pipe";
  if (w.depthMm !== null) {
    const cm = (Math.abs(w.depthMm) / 10).toFixed(1);
    return w.depthMm >= 0 ? `Water ${cm} cm over the soil` : `Water ${cm} cm under the soil`;
  }
  if (w.ourMm !== null) return `${w.state === "wet" ? "Wet" : "Dry"}, ${(w.ourMm / 10).toFixed(1)} cm from the radar`;
  return w.state ? w.state[0].toUpperCase() + w.state.slice(1) : "Not known";
}
